import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface LeadState {
  loading: boolean;
  error: string | null;
  success: boolean;
  successMessage: string | null;
  leadId: number | null;
}

export const initialState: LeadState = {
  loading: false,
  error: null,
  success: false,
  successMessage: null,
  leadId: null,
};

const leadSlice = createSlice({
  name: "lead",
  initialState,
  reducers: {
    setLeadLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setLeadSuccess(
      state,
      action: PayloadAction<{ message: string; leadId: number }>
    ) {
      state.success = true;
      state.successMessage = action.payload.message;
      state.leadId = action.payload.leadId;
      state.error = null;
    },
    setLeadError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
      state.success = false;
      state.successMessage = null;
      state.leadId = null;
    },
    resetLeadState(state) {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.successMessage = null;
      state.leadId = null;
    },
  },
});

export const {
  setLeadLoading,
  setLeadSuccess,
  setLeadError,
  resetLeadState,
} = leadSlice.actions;

export default leadSlice.reducer;

